var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","dark":"","outlined":"","rounded":""},on:{"click":_vm.downloadReport}},[_vm._v("Download Report")])
}
var staticRenderFns = []

export { render, staticRenderFns }